<script>
import http from '@/service/http'
import {mapState} from 'vuex'

export default {
  name: 'Form',
  data () {
    return {
      permissoes: [
        'usuario.visualizar',
        'usuario.inserir',
        'usuario.editar',
        'usuario.excluir',
        'cliente.visualizar',
        'cliente.inserir',
        'cliente.editar',
        'cliente.excluir',
        'como-conheceu.visualizar',
        'como-conheceu.inserir',
        'como-conheceu.editar',
        'como-conheceu.excluir',
        'financeiro-categoria.visualizar',
        'financeiro-categoria.inserir',
        'financeiro-categoria.editar',
        'financeiro-categoria.excluir',
        'financeiro-conta.visualizar',
        'financeiro-conta.inserir',
        'financeiro-conta.editar',
        'financeiro-conta.excluir',
        'financeiro-forma.visualizar',
        'financeiro-forma.inserir',
        'financeiro-forma.editar',
        'financeiro-forma.excluir',
        'financeiro-pagar.visualizar',
        'financeiro-pagar.inserir',
        'financeiro-pagar.editar',
        'financeiro-pagar.excluir',
        'financeiro-receber.visualizar',
        'financeiro-receber.inserir',
        'financeiro-receber.editar',
        'financeiro-receber.excluir',
        'financeiro-extrato.visualizar',
        'fornecedor.visualizar',
        'fornecedor.inserir',
        'fornecedor.editar',
        'fornecedor.excluir',
        'contato.visualizar',
        'contato.inserir',
        'contato.editar',
        'contato.excluir',
        'produto.visualizar',
        'produto.inserir',
        'produto.editar',
        'produto.excluir',
        'servico.visualizar',
        'servico.inserir',
        'servico.editar',
        'servico.excluir',
        'orcamento.visualizar',
        'orcamento.inserir',
        'orcamento.editar',
        'orcamento.excluir',
        'orcamento-pagamento.visualizar',
        'orcamento-pagamento.inserir',
        'orcamento-pagamento.editar',
        'orcamento-pagamento.excluir',
        'os.visualizar',
        'os.inserir',
        'os.editar',
        'os.excluir',
        'os.trocar-revisao',
        'equipamento.visualizar',
        'equipamento.inserir',
        'equipamento.editar',
        'equipamento.excluir',
        'tarefa.visualizar',
        'tarefa.inserir',
        'tarefa.editar',
        'tarefa.excluir',
        'marca.visualizar',
        'marca.inserir',
        'marca.editar',
        'marca.excluir',
        'venda.visualizar',
        'venda.inserir',
        'venda.editar',
        'venda.excluir',
        'estoque.visualizar',
        'estoque.inserir',
        'estoque.editar',
        'estoque.excluir',
        'compra.visualizar',
        'compra.inserir',
        'compra.editar',
        'compra.excluir',
        'revisao-tipo.visualizar',
        'revisao-tipo.inserir',
        'revisao-tipo.editar',
        'revisao-tipo.excluir',
        'viatura.visualizar',
        'viatura.inserir',
        'viatura.editar',
        'viatura.excluir',
        'grupo.visualizar',
        'grupo.inserir',
        'grupo.editar',
        'grupo.excluir',
        'objetivo.visualizar',
        'objetivo.inserir',
        'objetivo.editar',
        'objetivo.excluir',
        'cargo.visualizar',
        'cargo.inserir',
        'cargo.editar',
        'cargo.excluir',
        'marca.visualizar',
        'marca.inserir',
        'marca.editar',
        'marca.excluir',
        'canal.visualizar',
        'canal.inserir',
        'canal.editar',
        'canal.excluir',
        'arte.visualizar',
        'arte.inserir',
        'arte.editar',
        'arte.excluir',
        'tipo-estabelecimento.visualizar',
        'tipo-estabelecimento.inserir',
        'tipo-estabelecimento.editar',
        'tipo-estabelecimento.excluir',
        'ata.visualizar',
        'ata.inserir',
        'ata.editar',
        'ata.excluir'
      ],
      all: false,
      perfil: {
        id: '',
        perfil: '',
        ativo: true,
        permissao: [],
        permissoes: {}
      }
    }
  },
  mounted () {
    this.fecth()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id != null) {
        this.fecth()
      }
    },
    hasAll () {
      if (this.hasAll) {
        this.all = true
      } else {
        this.all = false
      }
    }
  },
  methods: {
    selectAll () {
      this.all = !this.all
      this.perfil.permissao = []
      if (this.all) {
        this.permissoes.forEach((p) => {
          this.perfil.permissao.push(p)
        })
      }
    },
    setPermissoes (permissoes) {
      this.perfil.permissao = []
      for (var p in permissoes) {
        this.perfil.permissao.push(permissoes[p].permissao)
      }
    },
    validate () {
      this.$validator.validateAll().then(success => {
        if (!success) {
          return false
        } else {
          this.submit()
        }
      })
    },
    async submit () {
      const verb = this.isNew ? 'post' : 'put'
      const url = this.isNew ? '/usuarios/perfis' : `/usuarios/perfis/${this.perfil.id}`
      const {data} = await http[verb](url, this.perfil)
      if (data != null) {
        this.$emit('update-perfis-list', {perfil: data.perfil})
        this.$router.push({name: 'perfis.index'})
      }
    },
    async fecth () {
      this.clear()
      const {id} = this.$route.params
      if (id !== undefined) {
        const {data} = await http.get(`/usuarios/perfis/${id}/edit`)
        this.perfil = data.perfil
        this.setPermissoes(data.perfil.permissoes)
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      }
    },
    clear () {
      this.perfil = {
        id: '',
        perfil: '',
        ativo: true
      }
    }
  },
  computed: {
    ...mapState(['loading']),
    isNew () {
      return this.perfil.id === ''
    },
    hasAll () {
      return this.perfil.permissao && this.perfil.permissao.length === this.permissoes.length
    }
  }
}
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div class="row">

            <div class="input-field col s12">
              <input name="perfil" id="perfil" type="text" v-validate data-vv-rules="required"
              :class="{invalid: errors.has('perfil')}" v-model="perfil.perfil">
              <label for="perfil">*Nome</label>
              <small class="red-text">{{ errors.first('perfil') }}</small>
            </div>

          </div>

          <div class="row">

            <div class="input-field col s12">
              <input type="checkbox" id="todas" v-model="all" primary @click="selectAll" />
              <label for="todas">Todas as permissões</label>
            </div>

          </div>

          <div class="row">

            <div class="col s12">
              <table class="responsive-table bordered highlight">
                <thead>
                  <tr>
                    <th class="text-xs-left">Permissões</th>
                    <th class="text-xs-center">Visualizar</th>
                    <th class="text-xs-center">Inserir</th>
                    <th class="text-xs-center">Editar</th>
                    <th class="text-xs-center">Excluir</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Atas</td>
                    <td>
                      <input type="checkbox" id="ata.visualizar" v-model="perfil.permissao" value="ata.visualizar" />
                      <label for="ata.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="ata.inserir" v-model="perfil.permissao" value="ata.inserir" />
                      <label for="ata.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="ata.editar" v-model="perfil.permissao" value="ata.editar" />
                      <label for="ata.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="ata.excluir" v-model="perfil.permissao" value="ata.excluir" />
                      <label for="ata.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Clientes</td>
                    <td>
                      <input type="checkbox" id="cliente.visualizar" v-model="perfil.permissao" value="cliente.visualizar" />
                      <label for="cliente.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="cliente.inserir" v-model="perfil.permissao" value="cliente.inserir" />
                      <label for="cliente.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="cliente.editar" v-model="perfil.permissao" value="cliente.editar" />
                      <label for="cliente.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="cliente.excluir" v-model="perfil.permissao" value="cliente.excluir" />
                      <label for="cliente.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Clientes :: Como Conheceu</td>
                    <td>
                      <input type="checkbox" id="como-conheceu.visualizar" v-model="perfil.permissao" value="como-conheceu.visualizar" />
                      <label for="como-conheceu.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="como-conheceu.inserir" v-model="perfil.permissao" value="como-conheceu.inserir" />
                      <label for="como-conheceu.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="como-conheceu.editar" v-model="perfil.permissao" value="como-conheceu.editar" />
                      <label for="como-conheceu.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="como-conheceu.excluir" v-model="perfil.permissao" value="como-conheceu.excluir" />
                      <label for="como-conheceu.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Clientes :: Cargo</td>
                    <td>
                      <input type="checkbox" id="cargo.visualizar" v-model="perfil.permissao" value="cargo.visualizar" />
                      <label for="cargo.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="cargo.inserir" v-model="perfil.permissao" value="cargo.inserir" />
                      <label for="cargo.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="cargo.editar" v-model="perfil.permissao" value="cargo.editar" />
                      <label for="cargo.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="cargo.excluir" v-model="perfil.permissao" value="cargo.excluir" />
                      <label for="cargo.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Contatos</td>
                    <td>
                      <input type="checkbox" id="contato.visualizar" v-model="perfil.permissao" value="contato.visualizar" />
                      <label for="contato.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="contato.inserir" v-model="perfil.permissao" value="contato.inserir" />
                      <label for="contato.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="contato.editar" v-model="perfil.permissao" value="contato.editar" />
                      <label for="contato.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="contato.excluir" v-model="perfil.permissao" value="contato.excluir" />
                      <label for="contato.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Compras</td>
                    <td>
                      <input type="checkbox" id="compra.visualizar" v-model="perfil.permissao" value="compra.visualizar" />
                      <label for="compra.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="compra.inserir" v-model="perfil.permissao" value="compra.inserir" />
                      <label for="compra.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="compra.editar" v-model="perfil.permissao" value="compra.editar" />
                      <label for="compra.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="compra.excluir" v-model="perfil.permissao" value="compra.excluir" />
                      <label for="compra.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Equipamentos</td>
                    <td>
                      <input type="checkbox" id="equipamento.visualizar" v-model="perfil.permissao" value="equipamento.visualizar" />
                      <label for="equipamento.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="equipamento.inserir" v-model="perfil.permissao" value="equipamento.inserir" />
                      <label for="equipamento.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="equipamento.editar" v-model="perfil.permissao" value="equipamento.editar" />
                      <label for="equipamento.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="equipamento.excluir" v-model="perfil.permissao" value="equipamento.excluir" />
                      <label for="equipamento.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Financeiro :: Categorias</td>
                    <td>
                      <input type="checkbox" id="financeiro-categoria.visualizar" v-model="perfil.permissao" value="financeiro-categoria.visualizar" />
                      <label for="financeiro-categoria.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-categoria.inserir" v-model="perfil.permissao" value="financeiro-categoria.inserir" />
                      <label for="financeiro-categoria.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-categoria.editar" v-model="perfil.permissao" value="financeiro-categoria.editar" />
                      <label for="financeiro-categoria.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-categoria.excluir" v-model="perfil.permissao" value="financeiro-categoria.excluir" />
                      <label for="financeiro-categoria.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Financeiro :: Contas</td>
                    <td>
                      <input type="checkbox" id="financeiro-conta.visualizar" v-model="perfil.permissao" value="financeiro-conta.visualizar" />
                      <label for="financeiro-conta.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-conta.inserir" v-model="perfil.permissao" value="financeiro-conta.inserir" />
                      <label for="financeiro-conta.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-conta.editar" v-model="perfil.permissao" value="financeiro-conta.editar" />
                      <label for="financeiro-conta.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-conta.excluir" v-model="perfil.permissao" value="financeiro-conta.excluir" />
                      <label for="financeiro-conta.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Financeiro :: Extrato</td>
                    <td>
                      <input type="checkbox" id="financeiro-extrato.visualizar" v-model="perfil.permissao" value="financeiro-extrato.visualizar" />
                      <label for="financeiro-extrato.visualizar"></label>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Financeiro :: Formas de Pagamento</td>
                    <td>
                      <input type="checkbox" id="financeiro-forma.visualizar" v-model="perfil.permissao" value="financeiro-forma.visualizar" />
                      <label for="financeiro-forma.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-forma.inserir" v-model="perfil.permissao" value="financeiro-forma.inserir" />
                      <label for="financeiro-forma.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-forma.editar" v-model="perfil.permissao" value="financeiro-forma.editar" />
                      <label for="financeiro-forma.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-forma.excluir" v-model="perfil.permissao" value="financeiro-forma.excluir" />
                      <label for="financeiro-forma.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Financeiro :: Pagar</td>
                    <td>
                      <input type="checkbox" id="financeiro-pagar.visualizar" v-model="perfil.permissao" value="financeiro-pagar.visualizar" />
                      <label for="financeiro-pagar.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-pagar.inserir" v-model="perfil.permissao" value="financeiro-pagar.inserir" />
                      <label for="financeiro-pagar.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-pagar.editar" v-model="perfil.permissao" value="financeiro-pagar.editar" />
                      <label for="financeiro-pagar.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-pagar.excluir" v-model="perfil.permissao" value="financeiro-pagar.excluir" />
                      <label for="financeiro-pagar.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Financeiro :: Receber</td>
                    <td>
                      <input type="checkbox" id="financeiro-receber.visualizar" v-model="perfil.permissao" value="financeiro-receber.visualizar" />
                      <label for="financeiro-receber.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-receber.inserir" v-model="perfil.permissao" value="financeiro-receber.inserir" />
                      <label for="financeiro-receber.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-receber.editar" v-model="perfil.permissao" value="financeiro-receber.editar" />
                      <label for="financeiro-receber.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="financeiro-receber.excluir" v-model="perfil.permissao" value="financeiro-receber.excluir" />
                      <label for="financeiro-receber.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Fornecedores</td>
                    <td>
                      <input type="checkbox" id="fornecedor.visualizar" v-model="perfil.permissao" value="fornecedor.visualizar" />
                      <label for="fornecedor.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="fornecedor.inserir" v-model="perfil.permissao" value="fornecedor.inserir" />
                      <label for="fornecedor.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="fornecedor.editar" v-model="perfil.permissao" value="fornecedor.editar" />
                      <label for="fornecedor.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="fornecedor.excluir" v-model="perfil.permissao" value="fornecedor.excluir" />
                      <label for="fornecedor.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Orçamentos</td>
                    <td>
                      <input type="checkbox" id="orcamento.visualizar" v-model="perfil.permissao" value="orcamento.visualizar" />
                      <label for="orcamento.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="orcamento.inserir" v-model="perfil.permissao" value="orcamento.inserir" />
                      <label for="orcamento.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="orcamento.editar" v-model="perfil.permissao" value="orcamento.editar" />
                      <label for="orcamento.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="orcamento.excluir" v-model="perfil.permissao" value="orcamento.excluir" />
                      <label for="orcamento.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Orçamentos :: Condições de Pagamento</td>
                    <td>
                      <input type="checkbox" id="orcamento-pagamento.visualizar" v-model="perfil.permissao" value="orcamento-pagamento.visualizar" />
                      <label for="orcamento-pagamento.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="orcamento-pagamento.inserir" v-model="perfil.permissao" value="orcamento-pagamento.inserir" />
                      <label for="orcamento-pagamento.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="orcamento-pagamento.editar" v-model="perfil.permissao" value="orcamento-pagamento.editar" />
                      <label for="orcamento-pagamento.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="orcamento-pagamento.excluir" v-model="perfil.permissao" value="orcamento-pagamento.excluir" />
                      <label for="orcamento-pagamento.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>OS's</td>
                    <td>
                      <input type="checkbox" id="os.visualizar" v-model="perfil.permissao" value="os.visualizar" />
                      <label for="os.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="os.inserir" v-model="perfil.permissao" value="os.inserir" />
                      <label for="os.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="os.editar" v-model="perfil.permissao" value="os.editar" />
                      <label for="os.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="os.excluir" v-model="perfil.permissao" value="os.excluir" />
                      <label for="os.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>OS's :: Revisão Tipo</td>
                    <td>
                      <input type="checkbox" id="revisao-tipo.visualizar" v-model="perfil.permissao" value="revisao-tipo.visualizar" />
                      <label for="revisao-tipo.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="revisao-tipo.inserir" v-model="perfil.permissao" value="revisao-tipo.inserir" />
                      <label for="revisao-tipo.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="revisao-tipo.editar" v-model="perfil.permissao" value="revisao-tipo.editar" />
                      <label for="revisao-tipo.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="revisao-tipo.excluir" v-model="perfil.permissao" value="revisao-tipo.excluir" />
                      <label for="revisao-tipo.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>OS's :: Revisão, Alterar Revisões em OS's</td>
                    <td>
                      <input type="checkbox" id="os.trocar-revisao" v-model="perfil.permissao" value="os.trocar-revisao" />
                      <label for="os.trocar-revisao"></label>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                  </tr>
                  <tr>
                    <td>Produtos</td>
                    <td>
                      <input type="checkbox" id="produto.visualizar" v-model="perfil.permissao" value="produto.visualizar" />
                      <label for="produto.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="produto.inserir" v-model="perfil.permissao" value="produto.inserir" />
                      <label for="produto.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="produto.editar" v-model="perfil.permissao" value="produto.editar" />
                      <label for="produto.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="produto.excluir" v-model="perfil.permissao" value="produto.excluir" />
                      <label for="produto.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Produtos :: Estoque</td>
                    <td>
                      <input type="checkbox" id="estoque.visualizar" v-model="perfil.permissao" value="estoque.visualizar" />
                      <label for="estoque.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="estoque.inserir" v-model="perfil.permissao" value="estoque.inserir" />
                      <label for="estoque.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="estoque.editar" v-model="perfil.permissao" value="estoque.editar" />
                      <label for="estoque.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="estoque.excluir" v-model="perfil.permissao" value="estoque.excluir" />
                      <label for="estoque.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Grupos de Serviço</td>
                    <td>
                      <input type="checkbox" id="grupo.visualizar" v-model="perfil.permissao" value="grupo.visualizar" />
                      <label for="grupo.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="grupo.inserir" v-model="perfil.permissao" value="grupo.inserir" />
                      <label for="grupo.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="grupo.editar" v-model="perfil.permissao" value="grupo.editar" />
                      <label for="grupo.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="grupo.excluir" v-model="perfil.permissao" value="grupo.excluir" />
                      <label for="grupo.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Serviços</td>
                    <td>
                      <input type="checkbox" id="servico.visualizar" v-model="perfil.permissao" value="servico.visualizar" />
                      <label for="servico.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="servico.inserir" v-model="perfil.permissao" value="servico.inserir" />
                      <label for="servico.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="servico.editar" v-model="perfil.permissao" value="servico.editar" />
                      <label for="servico.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="servico.excluir" v-model="perfil.permissao" value="servico.excluir" />
                      <label for="servico.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Objetivos</td>
                    <td>
                      <input type="checkbox" id="objetivo.visualizar" v-model="perfil.permissao" value="objetivo.visualizar" />
                      <label for="objetivo.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="objetivo.inserir" v-model="perfil.permissao" value="objetivo.inserir" />
                      <label for="objetivo.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="objetivo.editar" v-model="perfil.permissao" value="objetivo.editar" />
                      <label for="objetivo.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="objetivo.excluir" v-model="perfil.permissao" value="objetivo.excluir" />
                      <label for="objetivo.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Tarefas</td>
                    <td>
                      <input type="checkbox" id="tarefa.visualizar" v-model="perfil.permissao" value="tarefa.visualizar" />
                      <label for="tarefa.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="tarefa.inserir" v-model="perfil.permissao" value="tarefa.inserir" />
                      <label for="tarefa.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="tarefa.editar" v-model="perfil.permissao" value="tarefa.editar" />
                      <label for="tarefa.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="tarefa.excluir" v-model="perfil.permissao" value="tarefa.excluir" />
                      <label for="tarefa.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Marcas</td>
                    <td>
                      <input type="checkbox" id="marca.visualizar" v-model="perfil.permissao" value="marca.visualizar" />
                      <label for="marca.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="marca.inserir" v-model="perfil.permissao" value="marca.inserir" />
                      <label for="marca.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="marca.editar" v-model="perfil.permissao" value="marca.editar" />
                      <label for="marca.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="marca.excluir" v-model="perfil.permissao" value="marca.excluir" />
                      <label for="marca.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Famílias</td>
                    <td>
                      <input type="checkbox" id="familia.visualizar" v-model="perfil.permissao" value="familia.visualizar" />
                      <label for="familia.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="familia.inserir" v-model="perfil.permissao" value="familia.inserir" />
                      <label for="familia.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="familia.editar" v-model="perfil.permissao" value="familia.editar" />
                      <label for="familia.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="familia.excluir" v-model="perfil.permissao" value="familia.excluir" />
                      <label for="familia.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Usuários</td>
                    <td>
                      <input type="checkbox" id="usuario.visualizar" v-model="perfil.permissao" value="usuario.visualizar" />
                      <label for="usuario.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="usuario.inserir" v-model="perfil.permissao" value="usuario.inserir" />
                      <label for="usuario.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="usuario.editar" v-model="perfil.permissao" value="usuario.editar" />
                      <label for="usuario.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="usuario.excluir" v-model="perfil.permissao" value="usuario.excluir" />
                      <label for="usuario.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Canais de Venda</td>
                    <td>
                      <input type="checkbox" id="canal.visualizar" v-model="perfil.permissao" value="canal.visualizar" />
                      <label for="canal.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="canal.inserir" v-model="perfil.permissao" value="canal.inserir" />
                      <label for="canal.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="canal.editar" v-model="perfil.permissao" value="canal.editar" />
                      <label for="canal.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="canal.excluir" v-model="perfil.permissao" value="canal.excluir" />
                      <label for="canal.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Vendas</td>
                    <td>
                      <input type="checkbox" id="venda.visualizar" v-model="perfil.permissao" value="venda.visualizar" />
                      <label for="venda.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="venda.inserir" v-model="perfil.permissao" value="venda.inserir" />
                      <label for="venda.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="venda.editar" v-model="perfil.permissao" value="venda.editar" />
                      <label for="venda.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="venda.excluir" v-model="perfil.permissao" value="venda.excluir" />
                      <label for="venda.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Viaturas</td>
                    <td>
                      <input type="checkbox" id="viatura.visualizar" v-model="perfil.permissao" value="viatura.visualizar" />
                      <label for="viatura.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="viatura.inserir" v-model="perfil.permissao" value="viatura.inserir" />
                      <label for="viatura.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="viatura.editar" v-model="perfil.permissao" value="viatura.editar" />
                      <label for="viatura.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="viatura.excluir" v-model="perfil.permissao" value="viatura.excluir" />
                      <label for="viatura.excluir"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Área de Reclamação</td>
                    <td>
                      <input type="checkbox" id="reclamacao.visualizar" v-model="perfil.permissao" value="reclamacao.visualizar" />
                      <label for="reclamacao.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="reclamacao.inserir" v-model="perfil.permissao" value="reclamacao.inserir" />
                      <label for="reclamacao.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="reclamacao.editar" v-model="perfil.permissao" value="reclamacao.editar" />
                      <label for="reclamacao.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="reclamacao.excluir" v-model="perfil.permissao" value="reclamacao.excluir" />
                      <label for="reclamacao.excluir"></label>
                    </td>
                  </tr>

                  <tr>
                    <td>Motivos de Recusa</td>
                    <td>
                      <input type="checkbox" id="motivo.visualizar" v-model="perfil.permissao" value="motivo.visualizar" />
                      <label for="motivo.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="motivo.inserir" v-model="perfil.permissao" value="motivo.inserir" />
                      <label for="motivo.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="motivo.editar" v-model="perfil.permissao" value="motivo.editar" />
                      <label for="motivo.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="motivo.excluir" v-model="perfil.permissao" value="motivo.excluir" />
                      <label for="motivo.excluir"></label>
                    </td>
                  </tr>

                  <tr>
                    <td>Artes</td>
                    <td>
                      <input type="checkbox" id="arte.visualizar" v-model="perfil.permissao" value="arte.visualizar" />
                      <label for="arte.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="arte.inserir" v-model="perfil.permissao" value="arte.inserir" />
                      <label for="arte.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="arte.editar" v-model="perfil.permissao" value="arte.editar" />
                      <label for="arte.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="arte.excluir" v-model="perfil.permissao" value="arte.excluir" />
                      <label for="arte.excluir"></label>
                    </td>
                  </tr>

                  <tr>
                    <td>Tipos de Estabelecimento</td>
                    <td>
                      <input type="checkbox" id="tipo-estabelecimento.visualizar" v-model="perfil.permissao" value="tipo-estabelecimento.visualizar" />
                      <label for="tipo-estabelecimento.visualizar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="tipo-estabelecimento.inserir" v-model="perfil.permissao" value="tipo-estabelecimento.inserir" />
                      <label for="tipo-estabelecimento.inserir"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="tipo-estabelecimento.editar" v-model="perfil.permissao" value="tipo-estabelecimento.editar" />
                      <label for="tipo-estabelecimento.editar"></label>
                    </td>
                    <td>
                      <input type="checkbox" id="tipo-estabelecimento.excluir" v-model="perfil.permissao" value="tipo-estabelecimento.excluir" />
                      <label for="tipo-estabelecimento.excluir"></label>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>

          </div>

          <div class="row">

            <div class="input-field col s12">
              <input name="ativo" id="ativo" type="checkbox" v-model="perfil.ativo">
              <label for="ativo">Ativo</label>
            </div>

          </div>

          <div class="row">

            <div class="input-field col s12">
              <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/usuarios/perfis/form.vue